<template>
    <div>
        <div class="title">
            <h3 class="left">Options du contrat:</h3>
        </div>

        <div v-if="!options || options.length == 0">
            <h4>Aucune option définie.</h4>
        </div>

        <div v-else
             class="panel panel-default"
             data-pages="portlet"
             v-for="(option, idx) in options"
             :key="'contract-option-'+idx">
            <div class="panel-heading">
                <div class="panel-title">
                    <!-- <h3>{{option.option.name}}</h3> -->
                    <h3>{{optionLines[idx]}}</h3>
                </div>
                <div class="panel-controls">
                    <ul>
                        <li>
                            <a href="#"
                               class="portlet-collapse"
                               data-toggle="collapse">
                                <i class="pg-arrow_maximize"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="panel-body">
                <h4>Edition de la consigne</h4>
                <p>
                    <resource-form v-if="showInstructions[idx]"
                                   :model="instructions[idx].model"
                                   :schema="instructions[idx].schema"
                                   :triggers="instructions[idx].triggers"
                                   :contractTerminated="contract.terminated"
                                   @submit="handleOptionInstructionsEdition"></resource-form>
                </p>
            </div>
        </div>

    </div>
</template>

<style lang="scss" scoped>
    .panel-heading {
        padding: 15px 20px 10px 20px;
        .panel-title {
            h3 {
                font-size: 0.78rem;
                font-weight: bold;
                margin: 0;
                text-transform: none;
                line-height: 16px;
                color: #575757;
            }
            p {
                font-size: 0.75rem;
                font-weight: normal;
                margin: 0;
                text-transform: none;
                color: #575757;
                font-family: "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif;
            }
        }
    }

    .panel-body {
        display: none;
    }

    .pg-arrow_maximize {
        font-size: 16px;
        color: #fa808c !important;
    }
</style>

<script type="text/babel">
    import { parsingData } from 'components/Customer/InformationsContent/Contracts/commonLogic'
    import ResourceForm from "components/Forms/ResourceForm"

    import { mapActions } from 'vuex'

    export default {

        props: ['options', 'instructions', 'contract'],

        components: {
            ResourceForm,
        },

        data () {
            return {
                parsingData,
                showInstructions: []
            }
        },

        created () {
            const unwatchData = this.$watch(
                () => !_.isNil(this.options) && this.instructions.length && !_.isEmpty(this.contract),
                () => {
                    this.$nextTick()
                        .then(() => $('[data-pages="portlet"]').portlet())
                    unwatchData()
                }
            )

            this.$watch('instructions',
                (instructions) => {
                    this.showInstructions = _.map(instructions, () => false)
                    this.$nextTick()
                        .then(() => this.showInstructions = _.map(instructions, () => true))
                        .then(() => $('[data-pages="portlet"]').portlet())
                }, {
                    immediate: true
                })
        },

        methods: {

            ...mapActions('contract', [
                'updateOptionInstructions'
            ]),

            decodeOptionLine (contractOption) {
                const { option } = contractOption,
                    ret = "" + option.name,
                    additional = this.parseAdditionalOption(option)

                return _.isEmpty(additional) ?
                    ret : ret.concat(` (${additional})`)
            },

            parseAdditionalOption (option) {
                let ret = ""

                _.each(this.parsingData, ({ match, parse }) => {
                    if (match(option)) {
                        ret = parse(option, this.contract)
                        return false
                    }
                })

                return ret
            },

            renderForm (idx) {
                return !(_.isNil(this.instructions[idx]) || _.isEmpty(this.instructions[idx]))
            },

            handleOptionInstructionsEdition ($event) {
                const model = $event.data
                return this.updateOptionInstructions(model)
            },
        },

        computed: {
            optionLines () {
                return _.map(
                    this.options,
                    (option) => this.decodeOptionLine(option)
                )
            },
        },

    }
</script>



// WEBPACK FOOTER //
// client/components/Customer/ContractManagementContent/Domiciliation/ContractOptions.vue